import { Guardian } from '@xaamin/guardian';

Guardian.define('multiemisor.access', (user) => {
  return user.cliente?.servicios?.multi_emisor === true || user.cliente?.servicios?.multi_empresa === true;
});